import request from "@/utils/request";
import baseUrl from "@/api/baseUrl";

export default class Account {
  /**
   * 查询本公司账号
   * @param {Object} params
   */
  static list(params = {}) {
    return request.get(`${baseUrl.vip}/account/list`, params);
  }

  /**
   * 新增本公司账号
   * @param {Object} data
   */
  static add(data = {}) {
    return request.post(`${baseUrl.vip}/account/add`, data);
  }

  /**
   * 修改本公司账号
   * @param {Object} data
   */
  static edit(data = {}) {
    return request.put(`${baseUrl.vip}/account/edit`, data);
  }

  /**
   * 启用/禁用账号
   * @param {Object} data
   */
  static changeStatus(data = {}) {
    return request.put(`${baseUrl.vip}/account/changeStatus`, data);
  }

  /**
   * 重置密码
   * @param {Object} data
   */
  static resetPwd(data = {}) {
    return request.put(`${baseUrl.vip}/account/resetPwd`, data);
  }

  /**
   * 删除账号
   * @param {string|number} ids
   */
  static remove(ids) {
    return request.delete(`${baseUrl.vip}/account/${ids}`);
  }
}
